<app-top-nav [pageActions]="navActions"></app-top-nav>

<div class="main">
  <div class="wrapper">
    <div class="global-head-column">
      <div class="global-head-row">
        <div class="page-title">BULK</div>
      </div>
    </div>
    <div class="scroll-wrapper">
      <p-table
        #dt
        [columns]="cols"
        dataKey="filename"
        [value]="tableData$() | async"
        [scrollable]="true"
        [scrollHeight]="getScrollHeight()"
        [paginator]="true"
        [rows]="20"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 20, 50]"
      >
        <ng-template pTemplate="header" let-columns>
          <th
            *ngFor="let col of columns"
            [class.col--originalFileName]="col.field == 'originalFileName'"
            [class.col--creationDate]="col.field == 'creationDate'"
            [class.col--bulkConfigurationTypeName]="
              col.field == 'bulkConfigurationTypeName'
            "
            [class.col--isProcessed]="col.field == 'isProcessed'"
            [class.col--numberOfLines]="col.field == 'numberOfLines'"
            [class.col--numberOfSkippedLines]="
              col.field == 'numberOfSkippedLines'
            "
            [class.col--numberOfSuccessfulLines]="
              col.field == 'numberOfSuccessfulLines'
            "
            [class.col--numberOfErrors]="col.field == 'numberOfErrors'"
            [class.col--requestor]="col.field == 'requestor'"
          >
            <div class="status-flex">
              <div
                class="horizontal-flex"
                *ngIf="!checkSortIcon(col.field); else filterHeader"
              >
                {{ col.header }}
              </div>
              <ng-template #filterHeader>
                <div
                  class="horizontal-flex clickable"
                  [matMenuTriggerFor]="extendedFilter"
                  #menuTrigger="matMenuTrigger"
                >
                  {{ col.header }}
                  <ng-container
                    *ngIf="{
                      direction: (getFieldSort$(col.field) | async)
                    } as sort"
                  >
                    <mat-icon
                      class="sortIcon {{
                        sort.direction == 1
                          ? 'sort-ascending'
                          : 'sort-descending'
                      }}"
                      *ngIf="sort.direction"
                      >straight</mat-icon
                    >
                  </ng-container>
                  <mat-icon class="material-icons-outlined sortIcon"
                    >filter_alt</mat-icon
                  >
                  <ng-container
                    *ngIf="getFieldFilters$(col.field) | async as filters"
                  >
                    <span *ngIf="filters" class="clear-header-filters"
                      >({{ filters.length }})</span
                    >
                  </ng-container>
                </div>
                <mat-menu
                  class="column-filter-menu"
                  #extendedFilter="matMenu"
                  [hasBackdrop]="true"
                >
                  <app-column-filter
                    *ngIf="menuTrigger.menuOpen"
                    [values]="getFieldValues$(col.field) | async"
                    [template]="getFieldTemplate(col.field)"
                    [canSearch]="getFieldFilterSearch(col.field)"
                    [hasEmptyValue]="getFieldHasEmptyValue(col.field)"
                    [initialSelected]="getFieldFilters$(col.field) | async"
                    [initialSort]="getFieldSort$(col.field) | async"
                    [ignoredValues]="col.ignoredFilterValues"
                    (sort)="setSort(col.field, $event)"
                    (filter)="setFilter(col.field, $event)"
                    (closePopup)="menuTrigger.closeMenu()"
                  ></app-column-filter>
                </mat-menu>
              </ng-template>
            </div>
          </th>
          <th class="col--actions">
            <div class="clear-button">
              <button
                class="clear-button"
                mat-flat-button
                color="warn"
                (click)="clearAllFilter()"
                *ngIf="extendedFilterActive$ | async"
              >
                clear all
              </button>
            </div>
          </th>
        </ng-template>
        <ng-template pTemplate="body" let-bulk>
          <tr>
            <td class="col--originalFileName">
              <button
                class="chip clickable"
                mat-stroked-button
                (click)="
                  onDownloadOrigFile(
                    bulk.originalFileName,
                    bulk.blobContainerType
                  )
                "
              >
                <mat-icon class="material-icons-outlined">download</mat-icon>
              </button>
            </td>
            <td class="col--bulkConfigurationTypeName">
              {{ bulk.bulkConfigurationTypeName }}
            </td>
            <td class="col--creationDate">
              {{ bulk.creationDate | date: "dd/MM/yyyy HH:mm:ss" }}
            </td>
            <td class="col--isProcessed">
              <div *ngIf="bulk.isProcessed">
                <button
                  class="chip clickable"
                  mat-stroked-button
                  (click)="
                    onDownloadFile(bulk.fileName, bulk.blobContainerType)
                  "
                >
                  <mat-icon class="material-icons-outlined">download</mat-icon>
                </button>
              </div>
            </td>
            <td class="col--numberOfLines">
              {{ bulk.numberOfLines }}
            </td>
            <td class="col--numberOfSkippedLines">
              {{ bulk.numberOfSkippedLines }}
            </td>
            <td class="col--numberOfSuccessfulLines">
              {{ bulk.numberOfSuccessfulLines }}
            </td>
            <td class="col--numberOfErrors">
              {{ bulk.numberOfErrors }}
            </td>
            <td class="col--requestor">
              {{ bulk.requestor }}
            </td>
            <td class="col--actions">&nbsp;</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
